<template>
  <div>
    <BaseTable
      class="table-shadow"
      :headers="headers"
      :items="info"
      :loading="loading"
      :paginate="true"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      item-key="id_equipe"
      show-expand
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Consulta</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>

          <RegisterBottom
            v-can-access="567"
            @click="(dialog = true), (labelBtn = 'Salvar')"
          />
          <FilterMetaEquipe
            @selectedFilters="fetchMetaEquipe((filters = $event))"
          />
        </v-toolbar>
      </template>
      <template v-slot:[`item.id_band`]="{ item }">
        <BaseSegmento :segmento="item.id_band" />
      </template>
      <template v-slot:[`item.nome_equipe`]="{ item }">
        {{ item.nome_equipe | TitleCase }}
      </template>

      <template v-slot:[`item.qtd_indicadores`]="{ item }">
        {{ item.dados.length }}
      </template>

      <template v-slot:[`item.mes_ref`]="{ item }">
        {{ `${item.mes_ref}/${item.ano_ref}` }}
      </template>
      <template v-slot:[`item.acoes`]="{ item }">
        <!-- <v-btn @click="getData(item.id_equipe)" icon
          ><v-icon>mdi-eye</v-icon>
        </v-btn>-->
        <IconBottom :name="'view'" @click="getData(item.id_equipe)" />
      </template>

      <!-- expanded -->

      <template v-slot:[`item.data-table-expand`]="{ expand, isExpanded }">
        <v-btn small text v-if="!isExpanded" @click="expand(!isExpanded)">
          expandir
          <v-icon>mdi-chevron-down</v-icon>
        </v-btn>
        <v-btn text small v-else @click="expand(!isExpanded)">
          ocultar
          <v-icon>mdi-chevron-up</v-icon>
        </v-btn>
      </template>

      <template v-slot:expanded-item="{ headers, item }">
        <td class="pa-0" :colspan="headers.length">
          <ListaMetaEquipe :items="item.dados" />
        </td>
      </template>
    </BaseTable>
    <ModalCadMetaEquipe
      :dialog="dialog"
      :labelBtn="labelBtn"
      @close="dialog = false"
    />
    <ModalListas
      :item="team_id"
      :dialogColab="visible"
      @closeColab="visible = false"
    />
  </div>
</template>

<script>
import IconBottom from "@/components/shared/bottons/IconBottom";
import BaseTable from "@/components/shared/NewBaseTable";
import comissao from "@/services/http/comissaoService";
import RegisterBottom from "@/components/shared/bottons/RegisterBottom";
import ModalCadMetaEquipe from "./ModalCadMetaEquipe";
import FilterMetaEquipe from "./FilterMetaEquipe.vue";
import ListaMetaEquipe from "./ListaMetaEquipe.vue";
import BaseSegmento from "@/components/shared/BaseSegmento";
import ModalListas from "@/components/shared/ModalColaboradoresEquipe.vue";

export default {
  components: {
    BaseTable,
    FilterMetaEquipe,
    ModalCadMetaEquipe,
    RegisterBottom,
    ListaMetaEquipe,
    BaseSegmento,
    ModalListas,
    IconBottom
  },

  data() {
    return {
      loading: false,
      dialog: false,
      singleExpand: false,
      labelBtn: "",
      expanded: [],
      filters: "",
      headers: [
        { text: "Segmento", value: "id_band" },
        { text: "Departamento", value: "departamento" },
        { text: "Empresa/Equipe", value: "nome_equipe" },
        { text: "QTD Indicadores", value: "qtd_indicadores", align: "center" },
        { text: "Mês Ref", value: "mes_ref" },
        { text: "Ações", value: "acoes" }
      ],
      info: [],
      visible: false,
      team_id: ""
    };
  },

  methods: {
    async fetchMetaEquipe(filters) {
      this.loading = true;
      let { data } = await comissao()
        .metaEquipe()
        .show({ per_page: -1, ...filters });
      this.loading = false;
      const obj = this.groupByCompany(data.data, "id_equipe");
      this.info = Object.values(obj);
    },

    getData(team_id) {
      this.team_id = team_id;
      this.visible = true;
    },

    groupByCompany(array, key) {
      return array.reduce((result, currentValue) => {
        (result[currentValue[key]] = result[currentValue[key]] || {
          id_equipe: currentValue.id_equipe,
          id_band: currentValue.id_band,
          departamento: currentValue.departamento,
          nome_equipe: currentValue.nome_equipe,
          mes_ref: currentValue.mes_ref,
          ano_ref: currentValue.ano_ref,
          dados: []
        }).dados.push(currentValue);
        return result;
      }, {});
    }
  },

  mounted() {
    if (this.filters != {}) {
      const date = new Date().toISOString().substr(0, 7);
      const [year, month] = date.split("-");
      const filter = {
        ano_ref: parseInt(year),
        mes_ref: parseInt(month)
      };
      this.fetchMetaEquipe(filter);
    }
  }
};
</script>

<style></style>
